import React, { FunctionComponent } from "react";
import { Modal } from "react-bootstrap";

type OwnProps = {
  showModal?: boolean;
  onHide: () => any;
};

type Props = OwnProps;

const GroupStudentsModal: FunctionComponent<Props> = (props) => {
  return (
    <Modal
      show={props.showModal}
      animation={false}
      size="lg"
      centered
      backdropClassName="customDarkModalBackdrop in"
      onHide={props.onHide}
    >
      <Modal.Header closeButton className={"purpleModalHeader"}>
        <Modal.Title className="modalTitle">Group Students</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-center">
          Create Intervention Groups with one or more students who share the same intervention 
          plan and whose progress will be tracked together.
        </p>
        <p className="text-center">
          Groups can be created using ReadyCoach recommendations or by grouping students 
          manually.
        </p>
        <p className="text-center">
          All groups are managed in the <strong><i>Reading/Behavior Intervention Groups</i></strong> menu, 
          where they are clearly organized.
        </p>
      </Modal.Body>
    </Modal>
  );
};

export default GroupStudentsModal;
